module.exports = __webpack_public_path__ + "static/media/glasschain-logo.eaed2fa7.png";